const t = "styles-module__stay___s4r-i", _ = "styles-module__stay_value___ZADbH", s = "styles-module__total___1H7qN", a = "styles-module__total_value___tiSLL", l = {
  "cart-summary": "styles-module__cart-summary___G04Q6",
  stay: t,
  stay_value: _,
  total: s,
  total_value: a
};
export {
  l as default,
  t as stay,
  _ as stay_value,
  s as total,
  a as total_value
};
